import React, { useState } from "react";
import NiceModal, { useModal } from "@ebay/nice-modal-react"
import Modal from "/src/components/modal/Modal";
import useModalHelper from "/src/components/modal/hooks/useModalHelper";
import Form from "/src/components/form/Form";
import Field from "/src/components/UI/Field/Field";
import ButtonAction from "/src/components/UI/Button/Button";
import statementService from '/src/features/dataset/services/statementService';
import "./DeleteAllStatementModal.css"
import "/src/assets/css/polices.css";

import asyncWrapper from "/src/utils/asyncWrapper";

const DeleteAllStatementModal = NiceModal.create(({ nameDataset, title, data }) => {
    const modal = useModal();

    const { onClose } = useModalHelper(modal);
    const { deleteAllStatements } = statementService;
    const onSubmit = async () => {

        let [response, error] = await deleteAllStatements(nameDataset) //await asyncWrapper(timeout, 2000) //await deleteAllStatements(nameDataset)
        if (error !== null) {
            console.log(error);
            return;
        }
        setTimeout(() => {
            modal.resolve(true);
            onClose()
         } , 500)
        return;

    }

    function timeout(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    return (
        <Modal name="delete-all_informations" id={modal.id} autoClose="true" onClose={onClose}>
            <div className="leave-container">
                <div className="button-leave" id="close_modal_container" onClick={() => onClose({idIconModal:"close_modal_container"})} >
                    <i id="close_modal" className="fa fa-times" aria-hidden="true"></i>
                </div>
            </div>
            <Form className="modal-form">
                <Form.Title>Delete All Information</Form.Title>
                <Form.Body > <Field listLabelClassName="normal_size normal_font" label=" You really want to delete all information ?"></Field></Form.Body>
                <Form.Buttons>
                    <div className="button_center">
                        <ButtonAction className="validate" label="No" onClick={() => onClose()} style={{ marginRight: "20px"}} />
                        <ButtonAction className="cancel" label="Yes" onClick={onSubmit} />
                    </div>
                </Form.Buttons>
            </Form>
        </Modal >
    )
});

export default DeleteAllStatementModal;